import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ModalState {
    cancelBooking: boolean;
    updateDetails: boolean;
    cancellationPolicy: boolean;
    flightDetails: boolean;
    changeBooking: boolean;
    specialRequest: boolean;
    businessProfile: boolean;
    newBusinessProfile: boolean;
    roundTripModal: boolean;
    oneWayFlightDetails: boolean;
  }

const initialStateModalData: ModalState = {
    cancelBooking : false,
    updateDetails : false,
    cancellationPolicy : false,
    flightDetails : false,
    changeBooking : false,
    specialRequest : false,
    businessProfile: false,
    newBusinessProfile: false,
    roundTripModal: false,
    oneWayFlightDetails: false
};

export const modalSlice = createSlice({
    name : "modal",
    initialState : initialStateModalData,
    reducers: {
        setCancelBooking: (state, action: PayloadAction<boolean>) => {
            state.cancelBooking = action.payload;
        },
        setUpdateDetails: (state, action: PayloadAction<boolean>) => {
            state.updateDetails = action.payload;
        },
        setCancellationPolicy: (state, action: PayloadAction<boolean>) => {
            state.cancellationPolicy = action.payload;
        },
        setFlightDetails: (state, action: PayloadAction<boolean>) => {
            state.flightDetails = action.payload;
        },
        setChangeBooking: (state, action: PayloadAction<boolean>) => {
            state.changeBooking = action.payload;
        },
        setSpecialRequest: (state, action: PayloadAction<boolean>) => {
            state.specialRequest = action.payload;
        },
        setBusinessProfile: (state, action: PayloadAction<boolean>) => {
            state.businessProfile = action.payload;
        },
        setNewBusinessProfile: (state, action: PayloadAction<boolean>) => {
            state.newBusinessProfile = action.payload;
        },
        setRoundTripModal: (state, action: PayloadAction<boolean>) => {
            state.roundTripModal = action.payload;
        },
        setOneWayFlightDetails: (state, action: PayloadAction<boolean>) => {
            state.oneWayFlightDetails = action.payload;
        },

    }
})

export const {
    setCancelBooking,
    setUpdateDetails,
    setCancellationPolicy,
    setFlightDetails,
    setChangeBooking,
    setSpecialRequest,
    setBusinessProfile,
    setNewBusinessProfile,
    setRoundTripModal,
    setOneWayFlightDetails

} = modalSlice.actions;

export default modalSlice.reducer;